import { api } from '@utils/api/api'
import { Money, WalletTransferOrder } from '@interfaces'

export interface WalletPreOrder {
  portfolioId: string
  sourceAmount: Money
  targetCurrency: string
}

export interface WalletOrder {
  preOrderId: string
}

export async function getWalletTransferPreOrder(
  data: WalletPreOrder,
): Promise<WalletTransferOrder> {
  return api.post('/api/v1/cash/wallets/transfers/pre-order', data)
}

export async function getWalletTransferOrder(
  id: WalletOrder,
): Promise<WalletTransferOrder> {
  return api.post('/api/v1/cash/wallets/transfers/order', id)
}
